import { ModelAbstract } from '../index';
import { ORDER_TYPES, PRICEBOOK_TAGS } from '../../common/enums';
import { PriceBookContextModel } from '../../Context';

class CommonSectionModel extends ModelAbstract {
  constructor(higherOrderModel) {
    super(higherOrderModel);

    this._ignoreOnExport.push(
      'customerOrder',
      'isSupportsSpeechAnalytics',
      'isSupportsSonellaAI',
      'isSupportsMatchAddOnTermLengthToLocationQuote',
      'isSupportsDaas',
      'isAddon',
      'appState'
    );
  }

  /** @type {CustomerOrderModel} */
  get customerOrder() {
    return this.controller.customerOrder;
  }

  /** @type {AppStateModel} */
  get appState() {
    return this.controller.appState;
  }

  get lockedState() {
    return this.appState.locked;
  }

  get disabledState() {
    return this.appState.disabled;
  }

  get isSupportsSpeechAnalytics() {
    return PriceBookContextModel.hasPricebookTag(PRICEBOOK_TAGS.SUPPORTS_SPEECH_ANALYTICS);
  }

  get isSupportsSonellaAI() {
    return PriceBookContextModel.hasPricebookTag(PRICEBOOK_TAGS.SUPPORTS_SONELLA_AI);
  }

  get isSupportsMatchAddOnTermLengthToLocationQuote() {
    return PriceBookContextModel.hasPricebookTag(PRICEBOOK_TAGS.MATCH_ADD_ON_TERM_LENGTH_TO_LOCATION_QUOTE);
  }

  get isSupportsDaas() {
    return PriceBookContextModel.hasPricebookTag(PRICEBOOK_TAGS.SUPPORTS_NEW_DAAS);
  }

  get isAddon() {
    return this.customerOrder.orderType === ORDER_TYPES.ADD_ON;
  }
}

export default CommonSectionModel;
